export * from './lib/back-office-dashboard-shell.module';
